// extracted by mini-css-extract-plugin
export default {"subscribePrivacyTermsandConditions":"Mh1xW928qVVx4b1Vzeys"};